export default __webpack_public_path__ + "static/media/gallery_00.77b54c77.jpg";